<div class="wrapper" *ngIf="isLoading">
    <div class="overlay">
        <div class="spinner-wrapper">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</div>
